<script>
  import { audioPlayer } from '/stores.js';

  import IconPlayPause from '/components/Icons/IconPlayPause'

  export let src, title

  function onClick() {
    if ( $audioPlayer.src === src) {
      audioPlayer.togglePlay()
    } else {
      audioPlayer.load({
        src, 
        title: title || src,
        pagePath: location.pathname
      })
    }
    
  }

</script>

<div title={title} class="icon" on:click={onClick}>
  <IconPlayPause paused={$audioPlayer.paused || $audioPlayer.src !== src} />
</div>

<style>
  .icon {
    cursor: pointer;
  }
</style>